export const COLORS = {
  primary: {
    yellow: '#FFFB7D',
  },
  grayscale: {
    white: '#FFFFFF',
    gray50: '#F8F9FA',
    gray100: '#F3F5F7',
    gray200: '#ECEEF0',
    gray300: '#E2E5E8',
    gray400: '#D4D8DC',
    gray500: '#B5B9BD',
    gray600: '#8E9398',
    gray700: '#505458',
    gray800: '#3A3D40',
    gray900: '#252729',
    black: '#000000',
  },
};
